function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1a7.001 7.001 0 11-.002 14.002A7.001 7.001 0 018 1zm.339 5.42H6.984a.339.339 0 00-.339.338v.226a.34.34 0 00.339.339h.339v3.387h-.34a.339.339 0 00-.338.338v.226a.34.34 0 00.339.339h2.032a.339.339 0 00.339-.339v-.226a.339.339 0 00-.339-.338h-.339V6.758a.339.339 0 00-.338-.339zM8 3.934a.903.903 0 100 1.807.903.903 0 000-1.807z",
  fill: "#adc6ca",
  fillRule: "evenodd"
});

function SvgAtomIconFunctionalCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgAtomIconFunctionalCloseinline;